export default "__VITE_ASSET__Btt096sz__"